import React from 'react';
import PropTypes from 'prop-types';

const FullWidth = ({ color }) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 920 50"
    style={{ enableBackground: 'new 0 0 920 50' }}
    xmlSpace="preserve"
    preserveAspectRatio="none"
    width="100%"
    height="100%"
  >
    <g><g><rect fill={color} width="920" height="50" /></g></g>
  </svg>
);

FullWidth.propTypes = {
  color: PropTypes.string,
};

FullWidth.defaultProps = {
  color: '#27A9E1',
};

export default FullWidth;
